<button
  #settingsOrigin
  aria-label="Table settings"
  class="atn-ds-table-settings__trigger"
  title="Table settings"
  type="button"
  (click)="settingsClickHandler($event)"
>
  <i class="atn-icon atn-track-detail atn-blue"></i>
</button>

@if (store.settingsOpenSg()) {
  <atn-ds-attached-overlay
    [origin]="settingsOrigin"
    (backdropClick)="store.setSettingsOpen(false)"
  >
    <div class="atn-ds-table-settings__overlay">
      <div class="atn-ds-table-settings__wrap">
        <atn-ds-toggle-button
          label="Wrap Overflow"
          [active]="store.wrapSg()"
          (activeChange)="store.setWrap($event)"
        />
      </div>

      <div
        cdkDropList
        class="atn-ds-table-settings__columns"
        (cdkDropListDropped)="columnDropHandler($event)"
      >
        @for (column of store.orderedColumnsSg(); track column.id) {
          <div
            cdkDrag
            class="atn-ds-table-settings__column"
          >
            <atn-ds-checkbox
              [disabled]="!column.onVisibilityChange"
              [label]="column.label"
              [selected]="column.visible !== false"
              (selectedChange)="store.changeColumnVisibility(column, $event)"
            />
          </div>
        }
      </div>
    </div>
  </atn-ds-attached-overlay>
}
